import React from 'react'

import AppDetailsSection from '../UniversalSections/AppDetailsSection'
import ContactInfoSection from '../ResumeSections/ContactInfoSection'
import ExperienceSection from '../ResumeSections/ExperienceSection'
import SkillsSection from '../ResumeSections/SkillsSection'
import EducationSection from '../ResumeSections/EducationSection'
import ProjectSection from '../ResumeSections/ProjectSection'
import LinkSection from '../ResumeSections/LinkSection'
import ReferenceSection from '../ResumeSections/ReferenceSection'

import { 
    useFormContext, 
    FormProvider
} from "react-hook-form"

function ResumeViewer(props){

    const methods = useFormContext()
    
    return (
        <>
            <FormProvider {...methods}>
                <AppDetailsSection name="resume-details-sections" />
                <ContactInfoSection name="contact-section" />
                <ExperienceSection name="experience-section" />
                <EducationSection name="education-section" />
                <SkillsSection name="skills-section" />
                <ProjectSection name="project-section" />
                <LinkSection name="link-section" />
                <ReferenceSection name="reference-section" />
            </FormProvider>
        </>
    )

}

export default ResumeViewer